export const industries = [
  { value: 'logistics', label: 'Logistics' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'retail', label: 'Retail' },
];

export const phases = [
  { key: 'define', label: 'Define', color: 'bg-blue-500', description: 'Define the problem and project goals' },
  { key: 'measure', label: 'Measure', color: 'bg-purple-500', description: 'Measure current performance' },
  { key: 'analyze', label: 'Analyze', color: 'bg-amber-500', description: 'Analyze root causes' },
  { key: 'improve', label: 'Improve', color: 'bg-emerald-500', description: 'Implement improvements' },
  { key: 'control', label: 'Control', color: 'bg-rose-500', description: 'Control and sustain gains' },
];

export const getPhaseProgress = (projectPhases) => {
  if (!projectPhases) return 0;
  const completed = Object.values(projectPhases).filter(p => p.status === 'completed').length;
  return (completed / 5) * 100;
};
